require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_core-js@2.5.7@core-js/library/modules/es7.symbol.observable.js
// module id = 454
// module chunks = 0